export enum RevenueType {
  Labor = 'LABOR',
  Expense = 'EXPENSE',
  LaborAndExpense = "LABOR_AND_EXPENSE",
  Fee = 'SEPARATE_FEE',
  LaborFee = "LABOR_FEE",
  ExpenseFee = "EXPENSE_FEE",
  LaborRetainage = "LABOR_RETAINAGE_FEE",
  ExpenseRetainage = "EXPENSE_RETAINAGE_FEE",
  CAF = "CAF",
  ItemCatalog = "ITEM_CATALOG"
}
